import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/account")({
  component: AccountLayout,
});

function AccountLayout() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-semibold">Account</h1>
        <nav className="mt-4 flex gap-4 border-b border-ink/8 text-sm">
          <Tab to="/app/account">Profile</Tab>
          <Tab to="/app/account/sessions">Sessions</Tab>
        </nav>
      </div>
      <Outlet />
    </div>
  );
}

function Tab({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Link
      to={to}
      activeOptions={{ exact: true }}
      className="border-b-2 border-transparent pb-2 text-ink/55 hover:text-ink [&.active]:border-primary-600 [&.active]:text-primary-700"
    >
      {children}
    </Link>
  );
}
